import React, { useState, useEffect } from 'react';
import { Admin } from './admin';
import { Editor } from './editor';
import { useNavigate } from 'react-router-dom';


const btn = {
  padding: '5px',
  margin: '10px',
};
const err = {
  color: 'red',
};

export const Login = () => {

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [admin, setAdmin] = useState('');
  const [loading, setLoading] = useState(false);//ローディング状態
  const [maintenance,setMaintenance] = useState(false);

  const navigate = useNavigate();

  // タイムアウト付きfetch関数
  async function fetchWithTimeout(url, options = {}, timeout = 5000) {
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchPromise = fetch(url, { ...options, signal });
    const timeoutId = setTimeout(() => {
        controller.abort();
    }, timeout);
    try {
        return await fetchPromise;
    } finally {
        clearTimeout(timeoutId);
    }
  }
  // 再トライ付きAPI呼び出し関数（GET/POST両対応）
  async function fetchAPI(url, options = {}, retries = 5, timeout = 7000) {
    let attempts = 0;
    let lastError = null;
    while (attempts < retries) {
        try {
            const response = await fetchWithTimeout(url, options, timeout);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return await response.json(); // 成功時にJSONデータを返す
        } catch (error) {
            lastError = error;
            attempts += 1;
            console.warn(`Attempt ${attempts} failed: ${error.message}`);
            if (attempts >= retries) {
                throw lastError;
            }
        }
    }
  }

  useEffect(() => {
    document.title = 'LOGIN';
  }, []);

  const Maintenance_check = async() =>{
    setLoading(prevState => ({
        ...prevState,
        isEnabled:true,
        message: "サイト情報取得中..." // メッセージの変更
    }));
    const url = 'https://91irq05y3c.execute-api.ap-northeast-1.amazonaws.com/auth/api';
    const options = {
        method: 'GET', // GETまたはPOST
        headers: {
            'Content-Type': 'application/json',
        },
    };
    try{
        const json = await fetchAPI(url,options,500);
        setMaintenance(json['valid']);
        console.log("Maintenance_flag:",maintenance);
    }
    catch{
        console.log('Maintenance_flag取得失敗')
    }finally{
        setLoading(prevState => ({
        ...prevState,
        isEnabled:false,
        }));
    }
  }
  useEffect(() => {
    Maintenance_check();
  }, []);

  
  const handleSubmit = async (e) => {
    
    setLoading(prevState => ({
        ...prevState,
        isEnabled:true,
        message: "認証中..." // メッセージの変更
    }));
    e.preventDefault();
    const options = {
      method: 'POST', // GETまたはPOST
      headers: {
          'Content-Type': 'application/json',
      },
      body:JSON.stringify({ name, password }),
  };
    try {
      const responseData = await fetchAPI('https://91irq05y3c.execute-api.ap-northeast-1.amazonaws.com/auth/api', options);
      console.log(responseData);
      setError('認証成功');
      console.log(responseData);
      
      //setAdmin(responseData["Name"]);
      /*
      sessionStorage.setItem('ID', name);
      sessionStorage.setItem('User', responseData["Name"]);
      sessionStorage.setItem('Department', responseData["Department"]);
      sessionStorage.setItem('Room', responseData["Room"]);
*/
      const json = {};
      json['ID'] = name;
      json['User'] = responseData["Name"];
      json['Department'] = responseData["Department"];
      json['Room'] = responseData["Room"];

      Object.entries(json).map(([key,value]) => {
        sessionStorage.setItem(key,value);
      })

      const unique = sessionStorage.getItem('Unique');
      const currentyear = sessionStorage.getItem('Year');
      if(unique){
        navigate(`/form?unique=${currentyear + unique}`);
      }
      else{
        navigate('/');//Home
      }
      


    } catch (error) {
      console.error(error);
      setError('認証エラー パスワードが違います');
      setAdmin('一般');
    }finally{
      setLoading(prevState => ({
          ...prevState,
          isEnabled:false,
          message: "認証完了" // メッセージの変更
      }));
    }
  };


  return (
    <>
    {/* メンテナンス中のオーバーレイ */}
    {maintenance && (
        <div className="maintenance-overlay">
          <div className="maintenance-message">
            <p>現在メンテナンス中です。完了までお待ちください。<br/>急ぎの処置が必要な場合は、三好・小原までご連絡ください。</p>
          </div>
        </div>
      )}
    {/* ローディング中のスピナーとテキスト */}
    {loading.isEnabled && (
                // ローディング中のスピナーとテキストの表示
                <div className="spinner-overlay">
                    <div className="spinner"></div>
                    <div className="loading-text">{loading.message}</div>
                </div>
            )}
      <div style={{ marginTop: "70px" }}>
        <img src='logo192.png' height={50} width={50} style={{float:'left'}}/>
        <h1>信頼性業務依頼システム</h1>
        <h1>Login</h1>
      </div>
      <div>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Username:</label>
            <br />
            <input type="text" pattern="^[a-zA-Z0-9]+$" value={name} onChange={(e) => setName(e.target.value)} required/>
          </div>
          <div>
            <label>Password:</label>
            <br />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
          </div>
          {error && <p style={err}>{error}</p>}
          <button style={btn} type="submit">
            Login
          </button>
        </form>


        <div>
          {sessionStorage.getItem("Access") === "1" && <Admin />}
          {sessionStorage.getItem("Access") === "0" && <Editor />}
        </div>
      </div>
    </>
  );
};
